/**
 * Componente HomeSection
 * Sección principal de inicio con logo, título y navegación
 */
import React, { memo } from "react";
import { motion } from "framer-motion";
import { Trans } from "react-i18next";
import ComicButton from "../../shared/components/ComicButton/ComicButton";
import LanguageSelector from "../../shared/components/LanguageSelector";

const HomeSection = ({ goTo }) => {
    return (
        <motion.div
            key="home"
            className="absolute inset-0 flex flex-col items-center justify-center text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
        >
            <LanguageSelector />
            <div className="header-logos">
                <img src="logo-fucal.webp" alt="Logo FUCAL" className="responsive-img" />
                <img src="logo-uemc.webp" alt="Logo UEMC" className="responsive-img" />
            </div>
            <div>
                <img src="/titulo-zaquiel.webp" alt="Título Zaquiel" className="mx-auto w-3/4 md:w-1/2" />
                <div className="mt-8 flex flex-col items-center gap-4">
                    <ComicButton
                        buttonName={<Trans i18nKey="whoweare" />}
                        hoverBtnName={<Trans i18nKey="whoweare" />}
                        handleButtonClick={() => goTo("quienes-somos")}
                    />
                    <ComicButton
                        buttonName={<Trans i18nKey="chapters" />}
                        hoverBtnName={<Trans i18nKey="chapters" />}
                        handleButtonClick={() => goTo("capitulos")}
                    />
                    <ComicButton
                        buttonName={<Trans i18nKey="form" />}
                        hoverBtnName={<Trans i18nKey="form" />}
                        handleButtonClick={() => goTo("opiniones")}
                    />
                </div>
            </div>
            <div className="absolute bottom-4 text-center w-full">
                <button onClick={() => goTo("privacidad")} className="text-sm text-yellow-500 hover:underline">
                    <Trans i18nKey="privacyPolicy" />
                </button>
            </div>
        </motion.div>
    );
};

export default memo(HomeSection);
